import { render, staticRenderFns } from "./CopyClipboardButton.vue?vue&type=template&id=1fbe18f2&scoped=true"
import script from "./CopyClipboardButton.vue?vue&type=script&lang=js"
export * from "./CopyClipboardButton.vue?vue&type=script&lang=js"
import style0 from "./CopyClipboardButton.vue?vue&type=style&index=0&id=1fbe18f2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe18f2",
  null
  
)

export default component.exports